/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import last from 'lodash/last';
import cloneDeep from 'lodash/cloneDeep';

import {
    SecurityHelper,
    ScrollToHelper,
    Spinner,
    Select,
    announce,
    Stack,
    Inline,
    Box,
    AvailabilityTypes,
    DatePicker,
    localToday,
    Alert,
} from 'sarsaparilla';
import { withCompatRouter, COMPAT_ROUTER_PROP_TYPES } from 'sarsaparilla/legacy';
import { gnoment, gnomentToCalendarDate, calendarDateToGnoment } from 'shared-ui/gnoment';

import { withRecaptchaFallback } from 'shared-ui/recaptcha';
import { authModalActions } from 'shared-ui/auth/redux';
import AvailabilityMonths from '../../shared-components/detailed-availability/AvailabilityMonthsNew';

import DetailedAvailabilityPageLayout, {
    LayoutControlContext,
} from '../../shared-components/detailed-availability/DetailedAvailabilityPageLayout';
import DetailedAvailabilityPageSide from '../../shared-components/detailed-availability/DetailedAvailabilityPageSide';
import DetailedAvailabilityPageMain from '../../shared-components/detailed-availability/DetailedAvailabilityPageMain';
import DetailedAvailabilityFilter from '../../shared-components/detailed-availability/DetailedAvailabilityFilter';
import DetailedAvailabilityFilterItem from '../../shared-components/detailed-availability/DetailedAvailabilityFilterItem';
import DetailedAvailabilityGridAndActions from '../../shared-components/detailed-availability/DetailedAvailabilityGridAndActions';
import DetailedAvailabilityInformationRequired from '../../shared-components/detailed-availability/DetailedAvailabilityInformationRequired';
import DetailedAvailabilityNavigator from '../../shared-components/detailed-availability/DetailedAvailabilityNavigator';
import { shouldUseSmallerGrid } from '../../shared-components/utils/layoutUtils';
import { isDaySameAsTodayOnUTC } from '../../shared-components/utils/availability_utils';
import {
    loadPermitMapping,
    permitContentSelector,
} from '../../shared-components/slices/permitContent';

import DivisionDetailsModal from '../../shared-components/division-details/DivisionDetailsModal';
import { getGateA } from '../../shared-components/utils/gateA';
import RecaptchaChallengeModal from '../components/RecaptchaChallengeModal';
import * as pActions from '../actions/permit';
import * as aActions from '../actions/availability';
import * as recaptchaConstants from '../constants/recaptcha';
import {
    RULE_NOT_SPECIFIC_TO_DIVISION,
    readRuleValue,
    readRule,
    isEntryDateOnly,
    getCurrentTime,
    issuanceStatuses,
    addFilterValues,
    convertDateToNearestISOString,
    readRuleAsMoment,
    readRuleAsBoolean,
    shouldIncrementCheckoutDate,
    getMaxMemberQuota,
    hasRule,
    getParameterByName,
    errorsToStringList,
} from '../utils/utilsNew';
import * as types from '../constants';
import {
    getFilterErrors,
    seedQuotaFilters,
    seedExistingQuotaFilters,
    readQuotaFilters,
    isDayBlocked,
    isDayManagedByLottery,
    hasAccessToPermit,
    shouldIgnoreQuotaAfterFirstDay,
} from '../utils/availability-utils-new';
import AvailabilityFilters from '../components/detailed-availability-page-new/AvailabilityFilters';
import AvailabilityGrid from '../components/detailed-availability-page-new/AvailabilityGridTwo';

import TripItinerary from '../components/detailed-availability-page-new/TripItinerary';
import UnauthorizedErrorModal from '../components/detailed-availability-page-new/UnauthorizedErrorModal';
import OrganizedGroupQuestion from '../components/detailed-availability-page-new/OrganizedGroupQuestion';
import BookNow from '../components/detailed-availability-page-new/BookNow';

import { PERMIT, ISSUANCE, AVAILABILITIES } from '../props/permit';

const propTypes = {
    router: COMPAT_ROUTER_PROP_TYPES,
    availabilities: AVAILABILITIES,
    account: PropTypes.shape({}),
    issuance: ISSUANCE,
    error: PropTypes.shape({}),
    issuanceError: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
    fetchIssuanceError: PropTypes.shape({}),
    updateIssuanceError: PropTypes.shape({}),
    updateIssuanceResult: PropTypes.string,
    permit: PERMIT,
    divisionStayLimitRule: PropTypes.shape({
        value: PropTypes.number,
    }),
    aggSeasonRules: PropTypes.array,
    dispatch: PropTypes.func,
    nextAvailableDate: PropTypes.string,
    permitMapping: PropTypes.shape({}),
    recaptcha: PropTypes.object.isRequired,
};

const defaultProps = {
    permit: {},
};

const DAYS_TO_SKIP = 5;

export class DetailedAvailabilityPage extends React.Component {
    static propTypes = propTypes;
    static defaultProps = defaultProps;

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            loginModalShown: false,
            showCommercialAuthModal: false,
            detailedAvailabilityStartDate: this.getStartDate(),
            detailedAvailabilityEndDate: this.getStartDate().add(10, 'days'),
            monthsFetched: [],
            selectedItinerary: [],
            equipments: [],
            selectedQuotaToDisplay: types.GROUP_AVAILABILITY_KEY_NAME,
            initialQuotaFilterValues: {},
            quotaFilterValues: {},
            jumpDateFocused: false,
            displayWarning: false,
            dataSource: [],
            section: this.props.router.searchParams.get('section'),
            existingReservationId:
                this.props.router.searchParams.get('reservationId') || '',
            existingItinerary: [],
            sort: {
                column: 'view_order',
                isSorted: true,
                isAsc: true,
            },
            displayAvailability: true,
            contactFacility: '',
            fetchedAvailability: false,
            toggleFullView: false,
            divisionsForCurrentSection: [],
            startNextDay: false,
            parkingSelection: null,
            hasFetchedNextAvailableDate: null,
            isChallengeModalOpen: false,
        };
        this.generateDataSource = this.generateDataSource.bind(this);
        this.updateQuotaFilterValue = this.updateQuotaFilterValue.bind(this);
        this.updateQuotaFilterType = this.updateQuotaFilterType.bind(this);
        this.handleClearSelection = this.handleClearSelection.bind(this);
        this.handleNextAvailableClick = this.handleNextAvailableClick.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleJumpDateFocusChange = this.handleJumpDateFocusChange.bind(this);
        this.handleRegistration = this.handleRegistration.bind(this);
        this.handleUpdateSort = this.handleUpdateSort.bind(this);
        this.handleSectionSelection = this.handleSectionSelection.bind(this);
        this.handleQuestionResponse = this.handleQuestionResponse.bind(this);
        this.handleSelection = this.handleSelection.bind(this);
        this.handleToggleFullView = this.handleToggleFullView.bind(this);
        this.handleHikingChange = this.handleHikingChange.bind(this);
        this.checkAllDivs = this.checkAllDivs.bind(this);

        this.errorsRef = React.createRef();
    }

    componentDidMount() {
        // check url for params to see if we need to set jump date!
        const date = this.props.router.searchParams.get('date');
        if (date) {
            this.handleStartDateChange(date);
        }

        if (
            !hasAccessToPermit(
                SecurityHelper.getAccount(),
                this.props.router.params.permitId
            )
        ) {
            this.blockAccessToCommercial();
            return;
        }

        this.props.dispatch(loadPermitMapping());

        // clear availabilities in case availability data from another permit carries over
        this.props.dispatch(aActions.clearAvailabilitiesMap());
        if (this.props.router.params.permitId) {
            const apiCalls = [
                this.props.dispatch(
                    pActions.fetchPermit(this.props.router.params.permitId)
                ),
                this.props.dispatch(
                    pActions.fetchAggregateSeason(this.props.router.params.permitId)
                ),
            ];
            Promise.all(apiCalls).then(() => this.parsePermit());
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.permit.components?.permit_section_filter &&
            this.props.permit.permit_sections &&
            !this.state.section
        ) {
            const sectionOptions = this.getSectionOptions();
            if (sectionOptions.length > 0) {
                this.setState({ section: sectionOptions[0].value });
            }
        }

        if (this.props.permit.id && !prevProps.account && this.props.account) {
            if (!hasAccessToPermit(SecurityHelper.getAccount(), this.props.permit.id)) {
                this.blockAccessToCommercial();
                return;
            }

            if (SecurityHelper.isCommercialAccount()) {
                this.props.dispatch(aActions.clearAvailabilitiesMap());
                this.setState({ selectedItinerary: [] });
            }

            if (this.state.fetchedAvailability) {
                const issuanceId = this.state.existingReservationId.split(
                    types.RES_ID_DELIMITER
                )[0];
                this.fetchAvailability({
                    props: this.props,
                    permitId: this.props.router.params.permitId,
                    startDate: this.getStartDate(this.props),
                    commercialAccountFlag: SecurityHelper.isCommercialAccount(),
                    addQuotaId: issuanceId,
                });
            }

            if (!SecurityHelper.isCommercialAccount() && this.state.loginModalShown) {
                this.navigateToRegistration();
            }
        }

        if (this.state.selectedItinerary !== prevState.selectedItinerary) {
            this.updateStayLimit(this.state.selectedItinerary);
        }

        this.updateNextAvailableDate(prevProps);

        this.afterAvailabilitiesUpdated(prevProps);

        if (this.state.toggleFullView !== prevState.toggleFullView) {
            const toggledState = this.state.toggleFullView ? 'expanded' : 'collapsed';
            const toggledViewMessage = `Screen has been ${toggledState}`;
            announce(toggledViewMessage);
        }

        if (this.props.error && this.props.error !== prevProps.error) {
            const errorDiv = document.querySelector('.permit-notifications-errs');
            const scrollingDiv = document.querySelector(
                '.per-detailed-availability-content'
            );

            scrollingDiv.scrollTop = errorDiv.offsetTop;
            ScrollToHelper.scrollTo(0, 0);
        }
        if (
            this.state.dataSource &&
            this.state.dataSource.length > 0 &&
            this.state.dataSource !== prevState.dataSource
        ) {
            this.updateDivisionForSection();
        }

        if (
            !prevState.detailedAvailabilityStartDate.isSame(
                this.state.detailedAvailabilityStartDate
            ) &&
            this.state.dataSource[0]
        ) {
            const thisMonth = this.state.detailedAvailabilityStartDate
                .clone()
                .utc()
                .startOf('month');
            const nextMonth = thisMonth.clone().utc().add(1, 'month').startOf('month');

            const thisMonthUnfetched = !this.state.monthsFetched.includes(
                thisMonth.format('YYYY-MM')
            );
            const nextMonthUnfetched = !this.state.monthsFetched.includes(
                nextMonth.format('YYYY-MM')
            );

            const goingForwards = this.isMonthBoundary() === 1;
            const goingBackwards = this.isMonthBoundary() === -1;

            const largeSpan =
                this.state.detailedAvailabilityStartDate.diff(
                    prevState.detailedAvailabilityStartDate.format(),
                    'days'
                ) > DAYS_TO_SKIP;
            const missingMonth =
                thisMonthUnfetched &&
                this.state.detailedAvailabilityStartDate.format('YYYY-MM') ===
                    thisMonth.format('YYYY-MM');

            const fetchForward = goingForwards && nextMonthUnfetched && !largeSpan;
            const fetchBackward =
                (goingBackwards && thisMonthUnfetched) || largeSpan || missingMonth;

            if (fetchForward || fetchBackward) {
                this.fetchAvailability({
                    props: this.props,
                    permitId: this.props.router.params.permitId,
                    startDate: fetchForward ? nextMonth : thisMonth,
                    commercialAccountFlag: SecurityHelper.isCommercialAccount(),
                    fetchAdjacent: true,
                    addQuotaId: this.state.existingReservationId.split(
                        types.RES_ID_DELIMITER
                    )[0],
                });
            }
        }
    }

    componentWillUnmount() {
        this.props.dispatch(pActions.clearError());
        this.props.dispatch(pActions.clearFetchIssuanceError());
        this.props.dispatch(pActions.clearUpdateIssuanceError());
    }

    updateNextAvailableDate(prevProps) {
        // If we have found a new nextAvailableDate (someone has clicked the next available button)
        if (
            this.props.nextAvailableDate &&
            this.props.aggSeasonRules &&
            this.props.permit.time_zone &&
            prevProps.nextAvailableDate !== this.props.nextAvailableDate
        ) {
            // If the returned next available date is the end of the season, there are no further available dates
            const lastDay = readRuleAsMoment(
                'SeasonEnd',
                this.props.aggSeasonRules,
                this.props.permit.time_zone
            )
                .clone()
                .utc()
                .startOf('day');

            if (
                gnoment(this.props.nextAvailableDate).utc().startOf('day').isSame(lastDay)
            ) {
                this.setState({
                    displayWarning: true,
                    warning: 'There are no further available dates.',
                });
            } else {
                this.handleStartDateChange(this.props.nextAvailableDate);
                this.setState({
                    hasFetchedNextAvailableDate: true,
                    displayWarning: false,
                    warning: '',
                });
            }
        }
    }

    afterAvailabilitiesUpdated(prevProps) {
        // Availabilities have been updated
        if (this.props.availabilities !== prevProps.availabilities) {
            let filterValues = {};
            if (this.state.existingReservationId) {
                filterValues = seedExistingQuotaFilters(
                    this.props.availabilities,
                    get(this.props, 'permit'),
                    this.state.selectedQuotaToDisplay,
                    this.state.quotaFilterValues,
                    get(this.props, 'issuance'),
                    this.state.guidesCountTowardsGroupSize
                );
            } else {
                filterValues = seedQuotaFilters(
                    this.props.availabilities,
                    get(this.props, 'permit'),
                    this.state.selectedQuotaToDisplay,
                    this.state.quotaFilterValues
                );
            }
            const dataSource = this.generateDataSource({
                quotaFilterValues: filterValues.filterValues,
                selectedQuotaToDisplay: filterValues.mainFilterType,
                permit: this.props.permit,
                aggSeasonRules: this.props.aggSeasonRules,
                availabilities: this.props.availabilities,
            });

            this.setState({
                selectedQuotaToDisplay: filterValues.mainFilterType,
                quotaFilterValues: filterValues.filterValues,
                initialQuotaFilterValues: filterValues.filterValues,
                dataSource,
            });
        }
    }

    isMonthBoundary = () => {
        const dateMapDates = this.getDateMapDates();
        if (dateMapDates.length) {
            if (
                this.state.detailedAvailabilityEndDate.isAfter(
                    gnoment(last(dateMapDates))
                        .endOf('month')
                        .subtract(DAYS_TO_SKIP, 'day')
                )
            ) {
                return 1;
            }
            if (
                this.state.detailedAvailabilityStartDate
                    .clone()
                    .add(DAYS_TO_SKIP, 'day')
                    .isBefore(dateMapDates[0])
            ) {
                return -1;
            }
        }
        return 0;
    };

    getDateMapDates = () =>
        Object.keys(get(this.state, ['dataSource', 0, 'dateMap'], {}));

    getStartDate = (props = this.props) => {
        let source;
        const dateParam = this.props.router.searchParams.get('date');
        if (dateParam) {
            source = gnoment(dateParam);
        } else {
            source = getCurrentTime(props);
        }
        return source.utc(true).startOf('day').clone();
    };

    getDivisionType() {
        const { divisions } = this.props.permit;
        const keys = Object.keys(divisions);
        return keys[0] ? divisions[keys[0]].type : 'Division';
    }

    getSectionOptions() {
        const permitSections = get(this.props, 'permit.permit_sections', []);
        const options = permitSections.map((section) => ({
            value: section.name,
            label: section.name,
        }));

        return options;
    }

    getInformationRequirements = () => {
        const { quotaFilterValues } = this.state;
        const quotaKeys = Object.keys(quotaFilterValues);
        const hasQuotaSize = quotaKeys.join(',').includes('QuotaUsageByMember');
        const customRequirements = [];

        const hasSizeRequirement =
            hasQuotaSize &&
            !quotaFilterValues.QuotaUsageByMemberDaily > 0 &&
            !quotaFilterValues.QuotaUsageByMember > 0;

        const hasWatercraftRequirement = quotaKeys.includes('QuotaUsageByWatercraft');

        if (hasWatercraftRequirement && !quotaFilterValues.QuotaUsageByWatercraft) {
            customRequirements.push('Watercraft amount');
        }

        const hasTypeRequirement =
            get(this.props, 'permit.components.permit_section_filter') &&
            !this.state.section;
        const divisionType = this.getDivisionType();

        return {
            isRequired:
                hasTypeRequirement || hasSizeRequirement || !!customRequirements.length,
            divisionType,
            hasTypeRequirement,
            hasSizeRequirement,
            customRequirements,
        };
    };

    getOverlay() {
        if (
            get(this.props, 'permit.components.permit_section_filter') &&
            this.state.section === ''
        ) {
            return 'Please select Permit type';
        }
        // For fossil creek, show overlay message  when special parking is selected
        // and no choice has been chosen to acknowledge parking notice
        const showQuestionaire = this.isShowQuestionaire();

        if (showQuestionaire && this.state.parkingSelection === null) {
            return 'Please acknowledge parking notice';
        }
        return getFilterErrors(this.state.quotaFilterValues)[0];
    }

    blockAccessToCommercial() {
        this.setState({ showCommercialAuthModal: true });
    }

    parsePermit = () => {
        if (get(this.props, 'permit.components.reservation_type_question')) {
            this.setState({ displayAvailability: false, contactFacility: '' });
        }

        this.updateRules();

        // read recarea
        let recId = 0;
        if (get(this.props, 'permit.recareas[0]')) {
            recId = this.props.permit.recareas[0];
        }
        this.props.dispatch(pActions.fetchRecarea(recId));
        // set equipments from permit
        this.setState({
            equipments: this.props.permit.equipments,
        });
        // fetch issuance if we're in a modify quota state
        if (this.state.existingReservationId) {
            this.fetchExistingRes();
        } else {
            // read availabilities for all divisions at once
            this.fetchAvailability({
                props: this.props,
                permitId: this.props.router.params.permitId,
                startDate: this.getStartDate(),
                commercialAccountFlag: SecurityHelper.isCommercialAccount(),
                addQuotaId: '',
                fetchAdjacent: true,
            });
        }
    };

    fetchAdjacentMonth = (date) => {
        // If we're at a month boundary, fetch the next one.
        if ([1, -1].includes(this.isMonthBoundary())) {
            const startDate = date.add(this.isMonthBoundary(), 'month').startOf('month');
            this.fetchAvailability({
                props: this.props,
                permitId: this.props.router.params.permitId,
                startDate,
                commercialAccountFlag: SecurityHelper.isCommercialAccount(),
                addQuotaId: this.state.existingReservationId.split(
                    types.RES_ID_DELIMITER
                )[0],
            });
        }
    };

    focusErrorNotification = () => {
        if (this.errorsRef.current) this.errorsRef.current.focus();
    };

    updateRules = () => {
        const { permit } = this.props;
        const guidesCountTowardsGroupSize = hasRule(
            types.GUIDES_COUNT_TOWARDS_GROUP_SIZE,
            get(permit, 'rules', [])
        );
        const disableGroupList = hasRule('DisableGroupList', get(permit, 'rules', []));
        const ruleLotteryRegistrationOnly = hasRule(
            types.LOTTERY_REGISTRATION_ONLY,
            get(permit, 'rules', [])
        );
        const lotteryOnlyError = ruleLotteryRegistrationOnly
            ? 'This permit can only be purchased through the lottery.'
            : '';

        // maybe put this in a ruleMap?
        this.setState({
            guidesCountTowardsGroupSize,
            disableGroupList,
            lotteryOnlyError,
        });
    };

    fetchExistingRes = () => {
        // load existing issuance
        const issuanceId = this.state.existingReservationId.split(
            types.RES_ID_DELIMITER
        )[0];
        const permitId = this.state.existingReservationId.split(
            types.RES_ID_DELIMITER
        )[1];
        this.props
            .dispatch(pActions.fetchUnpaidIssuance(issuanceId, permitId))
            .then(() => {
                if (!this.props.fetchIssuanceError) {
                    // read availabilities for all divisions at once
                    this.fetchAvailability({
                        props: this.props,
                        permitId: this.props.router.params.permitId,
                        startDate: this.getStartDate(),
                        commercialAccountFlag: SecurityHelper.isCommercialAccount(),
                        addQuotaId: issuanceId,
                        fetchAdjacent: true,
                    });

                    const itinerary = [];
                    const entryDateOnly = isEntryDateOnly(
                        this.props.permit.rules,
                        Object.keys(this.props.permit.divisions)
                    );
                    const permit = this.props.permit;
                    if (!entryDateOnly) {
                        // multi-day itinerary
                        this.props.issuance.itinerary.forEach((item) => {
                            itinerary.push({
                                startDate: gnoment(item.start_date)
                                    .utc()
                                    .format(types.AVAILABILITY_KEY_MAP_FORMAT),
                                endDate: gnoment(item.end_date)
                                    .utc()
                                    .format(types.AVAILABILITY_KEY_MAP_FORMAT),
                                division: this.props.permit.divisions[item.division_id],
                                permit,
                            });
                        });
                    } else {
                        const division =
                            this.props.permit.divisions[this.props.issuance.division_id];
                        const item = {
                            startDate: gnoment(this.props.issuance.start_date)
                                .utc()
                                .format(types.AVAILABILITY_KEY_MAP_FORMAT),
                            endDate: gnoment(this.props.issuance.start_date)
                                .utc()
                                .format(types.AVAILABILITY_KEY_MAP_FORMAT),
                            division,
                            permit,
                        };
                        itinerary.push(item);
                    }
                    this.handleSelection(itinerary, false);

                    const clearDates =
                        'Reservations must be cancelled to change the start date. Group size may only be decreased.';
                    let modifyWarning = `Start date of reservation cannot be modified. ${clearDates}`;
                    if (
                        this.props.issuance.status ===
                            issuanceStatuses.get(types.PERMIT_PRELIMINARY) ||
                        this.props.issuance.status ===
                            issuanceStatuses.get(types.PERMIT_IN_PROGRESS)
                    ) {
                        modifyWarning = clearDates;
                    }
                    this.setState(
                        {
                            equipments: this.props.issuance.equipments,
                            existingItinerary: itinerary,
                            displayWarning: true,
                            warning: modifyWarning,
                        },
                        () => {
                            // halve equipment quotas if we're Pere Marquette
                            if (
                                this.props.issuance.permit_id === types.PERE_MARQUETTE_ID
                            ) {
                                const { equipments } = this.updatePereMarquetteFilter(
                                    this.props.issuance,
                                    true
                                );
                                this.setState({ equipments });
                            }
                        }
                    );
                } else {
                    // issuance not found or cancelled/removed from cart - do default behavior
                    this.fetchAvailability({
                        props: this.props,
                        permitId: this.props.router.params.permitId,
                        startDate: this.getStartDate(),
                        commercialAccountFlag: SecurityHelper.isCommercialAccount(),
                        addQuotaId: '',
                        fetchAdjacent: true,
                    });
                }
            })
            .catch(() => {
                // avoid throwing error up
                // reservation failed to load, will be handled by reducer GET_ISSUANCE_ERROR
            });
    };

    fetchAvailability({
        permitId,
        startDate,
        commercialAccountFlag,
        addQuotaId,
        fetchAdjacent,
    }) {
        if (this.state.monthsFetched.includes(startDate.format('YYYY-MM'))) {
            return;
        }

        this.setState({
            fetchedAvailability: true,
            monthsFetched: [
                ...this.state.monthsFetched,
                startDate.clone().startOf('month').format('YYYY-MM'),
            ],
        });

        if (!startDate.isValid() || this.state.lotteryOnlyError) return;

        this.props
            .dispatch(
                aActions.fetchAvailabilityAllDivisions({
                    permitId,
                    startDate,
                    commercialAccountFlag,
                    addQuotaId,
                })
            )
            .then(() => {
                if (fetchAdjacent) {
                    this.fetchAdjacentMonth(startDate);
                }
            });
    }

    handleSectionSelection(e) {
        const section = e.target.value;

        this.setState({ section }, () => {
            // clear out any filters
            const quotaFilterValues = { ...this.state.quotaFilterValues };
            Object.keys(quotaFilterValues).forEach((filter) => {
                quotaFilterValues[filter] = '';
            });

            // generate a new data source!
            const dataSource = this.generateDataSource({
                quotaFilterValues,
            });
            // Special case: User has answered no to parking question and are navigating to a new selection
            // reset the availability visibility
            if (this.state.parkingSelection === 'no') {
                this.setState({ displayAvailability: true });
            }
            // also clear out any itinerary and parking questionairs
            this.setState({
                dataSource,
                quotaFilterValues,
                selectedItinerary: [],
                parkingSelection: null,
            });
            this.updateDivisionForSection();
        });
    }

    updateDivisionForSection() {
        const divisionsForCurrentSection = [];
        if (this.state.dataSource) {
            this.state.dataSource.forEach((val) => {
                divisionsForCurrentSection.push(val.division ? val.division.id : '');
            });
            this.setState({ divisionsForCurrentSection });
        }
    }

    resetSelection() {
        const { selectedItinerary } = this.state;
        if (selectedItinerary.length) {
            this.setState({
                selectedItinerary: [],
            });
        }
    }

    handleSelection(newItinerary, shouldUpdateDivisionStayLimit) {
        if (shouldUpdateDivisionStayLimit) {
            this.updateStayLimit(newItinerary);
        }

        const selectedItinerary = [...newItinerary];
        this.setState({ selectedItinerary });
    }

    updateStayLimit(itinerary) {
        if (
            itinerary &&
            itinerary.length &&
            this.props.permit.components.reload_stay_limit
        ) {
            const curItinerary = itinerary[itinerary.length - 1];
            const issObj = {
                permit_id: curItinerary.permit.id,
                division_id: curItinerary.division.id,
                start_date: gnoment.utc(curItinerary.startDate),
            };
            this.props.dispatch(pActions.fetchStayLimitRule(issObj)).then(() => {
                const dataSource = this.state.dataSource.slice();
                for (let i = 0; i < dataSource.length; i++) {
                    if (dataSource[i].division.id === curItinerary.division.id) {
                        dataSource[i].division.stayLimit =
                            get(this.props, 'divisionStayLimitRule.value', 0) /
                            24 /
                            60 /
                            60;
                    }
                }
                this.setState({ dataSource });
            });
        }
    }

    handleClearSelection() {
        // clear selection, sort by view_order
        this.setState({
            sort: {
                column: 'view_order',
                isSorted: true,
                isAsc: true,
            },
            selectedItinerary: [],
        });
    }

    // Handle next available click will navigate to the next available date based on the current
    // availabilities
    handleNextAvailableClick() {
        // loop through dates from current startDate into the future.
        // check each division for quota availability vs. quotaFilters on that date.
        // short circuit on first true.
        let dayIterator = gnoment().utc().startOf('day');
        if (
            this.state.detailedAvailabilityStartDate &&
            this.state.detailedAvailabilityStartDate
                .utc()
                .startOf('day')
                .isAfter(dayIterator)
        ) {
            dayIterator = this.state.detailedAvailabilityStartDate
                .clone()
                .utc()
                .startOf('day');
        }
        const divisionKeys = Object.keys(this.props.availabilities);
        const { quotaFilterValues } = this.state;
        const quotaTypeKeys = Object.keys(quotaFilterValues).filter(
            (key) => key !== 'guides'
        );
        let nextAvailableCutoff = dayIterator.clone().utc().endOf('month').startOf('day');
        // Date that we will need to fetch availability after
        const months = this.state.monthsFetched.slice();

        if (months.length > 0) {
            // Sort the fetched months
            // sort the data by date using gnoment.js
            months.sort((left, right) => {
                return gnoment.utc(left).diff(gnoment.utc(right));
            });
            // Increase cutoff for searching for available dates to the end of the furthest pulled availability
            nextAvailableCutoff = gnoment(months[months.length - 1])
                .utc()
                .endOf('month')
                .startOf('day');
        }

        const lastDay = readRuleAsMoment(
            'SeasonEnd',
            this.props.aggSeasonRules,
            this.props.permit.time_zone
        )
            .clone()
            .utc()
            .startOf('day');
        let foundDate = null;
        let exit = null;

        // No found date for the currently fetched availabilities, so we need to fetch more
        while (!dayIterator.isAfter(lastDay) && !foundDate && !exit) {
            // We are at or past the current date and foundDate is false
            // If the day in question is the same as the end of the month or if it is after
            if (
                dayIterator.isAfter(nextAvailableCutoff) &&
                !this.state.hasFetchedNextAvailableDate
            ) {
                this.props.dispatch(
                    aActions.fetchNextAvailable(this.props.router.params.permitId)
                );
                // Exit the while loop using flag
                exit = true;
                continue;
            }
            // Take the first day that comes back
            const dayString = dayIterator.clone().format();
            const tempDay = this.checkAllDivs(
                dayIterator,
                dayString,
                divisionKeys,
                quotaFilterValues,
                quotaTypeKeys
            );
            if (!foundDate && tempDay) {
                // Found date, while loop should exit
                foundDate = tempDay;
                continue;
            }
            dayIterator.add(1, 'day');
        }
        // Initial availability has provided a found date
        if (foundDate) {
            this.handleStartDateChange(foundDate);
        }
        // We have attempted to fetch the next available date and their has been no found date
        else if (this.state.hasFetchedNextAvailableDate) {
            this.setState({
                displayWarning: true,
                warning: 'There are no further available dates.',
            });
        }
    }

    checkAllDivs(day, dayString, divisionKeys, quotaFilterValues, quotaTypeKeys) {
        const quotaTypeKeysLength = quotaTypeKeys.length;
        let result = null;

        divisionKeys.forEach((divisionKey) => {
            const { quota_type_maps: quotaTypeMaps } =
                this.props.availabilities[divisionKey].result;
            let avail = 0;
            const guideFilterValue = quotaFilterValues.guides || 0;
            if (quotaTypeKeysLength !== 0) {
                quotaTypeKeys
                    .filter((key) => key !== 'guides')
                    .forEach((quotaTypeKey) => {
                        const remaining = get(
                            quotaTypeMaps,
                            `[${quotaTypeKey}][${dayString}].remaining`,
                            -1
                        );
                        if (
                            quotaFilterValues[quotaTypeKey] + guideFilterValue <=
                                remaining &&
                            remaining !== 0
                        ) {
                            avail += 1;
                        }
                    });
                if (
                    avail === quotaTypeKeysLength &&
                    !isDayManagedByLottery(day, this.props) &&
                    !result
                ) {
                    // We have found the date
                    result = day;
                }
            }
        });
        return result;
    }

    handleStartDateChange(date) {
        if (!date) return;

        const detailedAvailabilityStartDate = gnoment(date).utc(true).startOf('day');

        this.setState(
            {
                detailedAvailabilityStartDate,
                detailedAvailabilityEndDate: detailedAvailabilityStartDate
                    .clone()
                    .add(10, 'days'),
            },
            () => {
                this.setState({
                    dataSource: this.generateDataSource(),
                });
                this.updateStayLimit(this.state.selectedItinerary);
            }
        );
    }

    handleJumpDateFocusChange({ focused }) {
        this.setState({ jumpDateFocused: focused });
    }

    handleRegistration() {
        const loggedIn = SecurityHelper.isLoggedIn();
        if (!loggedIn) {
            this.setState({ loginModalShown: true });
            this.props.dispatch(authModalActions.openLoginModal());
            return;
        }

        if (!hasAccessToPermit(SecurityHelper.getAccount(), this.props.permit.id)) {
            this.blockAccessToCommercial();
            return;
        }
        this.navigateToRegistration();
    }

    handleUpdateSort(sort) {
        this.setState({
            sort,
        });
    }

    handleQuestionResponse(event) {
        const contactFacility = event.target.value;
        switch (contactFacility) {
            case 'yes':
                this.setState({ displayAvailability: false, contactFacility });
                break;
            default:
                this.setState({ displayAvailability: true, contactFacility: 'no' });
                break;
        }
    }

    handleDivisionDetailsClick = (divisionId) => {
        this.setState({
            selectedDivisionId: divisionId,
            isDivisionDetailsModalOpen: true,
        });
    };

    closeDivisionDetailsModal = () =>
        this.setState({ isDivisionDetailsModalOpen: false });

    async navigateToRegistration() {
        const { selectedItinerary: itinerary } = this.state;
        if (itinerary.length <= 0) {
            return;
        }

        // Defer to the v2 challenge modal when a challenge is already required.
        // Must run before isLoading is set, otherwise the early return leaves the
        // flag stuck and the modal's Continue button spins forever.
        if (
            this.props.recaptcha.isChallengeRequired &&
            !this.state.isChallengeModalOpen
        ) {
            this.setState({ isChallengeModalOpen: true });
            return;
        }

        this.setState({ isLoading: true });
        const firstItineraryItem = itinerary[0];
        const lastItineraryItem = itinerary[itinerary.length - 1];
        let endDate = gnoment(lastItineraryItem.endDate);

        // We only care about the entry date in this case. The user will be able to select an end date on the
        // permit registration page. Unless date has been set already on the permit registration page,
        // set the end date to undefined
        if (isEntryDateOnly(this.props.permit.rules, [firstItineraryItem.division.id])) {
            const queryDate = getParameterByName();
            if (queryDate && this.state.existingItinerary.length) {
                endDate = gnoment(queryDate);
            } else {
                endDate = undefined;
            }
        }

        let item = {
            permit_id: firstItineraryItem.permit.id,
            division_id: firstItineraryItem.division.id,
            user_id: SecurityHelper.getAccount().account_id,
            start_date: gnoment(firstItineraryItem.startDate),
            end_date: endDate,
            status: issuanceStatuses.get(types.PERMIT_PRELIMINARY),
            permit_type: this.state.section,
            animals: [],
            pets: [],
        };

        item = Object.assign(item, addFilterValues(this.state.quotaFilterValues));

        // double equipment quotas if we're Pere Marquette
        if (item.permit_id === types.PERE_MARQUETTE_ID) {
            item = this.updatePereMarquetteFilter(item);
        }

        const itineraryEntries = itinerary.map((itin) => {
            return {
                start_date: convertDateToNearestISOString(gnoment(itin.startDate)),
                end_date: convertDateToNearestISOString(gnoment(itin.endDate)),
                division_id: itin.division.id,
            };
        });
        item.itinerary = itineraryEntries;

        const recaptcha = await getGateA(
            this.props.recaptcha,
            recaptchaConstants.CH_AVAILABILITY_BOOKING
        );

        this.dispatchIssuance(item, recaptcha);
    }

    getUpdatedExistingIssuanceGroupMembers = (issuance) => {
        let groupInfo = [];
        if (issuance.group_info) {
            groupInfo = issuance.group_info.map((member) => {
                const newMember = { ...member };

                const issStart = gnoment(issuance.start_date);
                const issEnd = gnoment(issuance.end_date);
                if (this.state.disableGroupList) {
                    newMember.start_date = issuance.start_date;
                    newMember.end_date = issuance.end_date;
                    return newMember;
                }

                if (member.start_date) {
                    if (gnoment(member.start_date).isBefore(issStart)) {
                        newMember.start_date = issuance.start_date;
                    } else if (gnoment(member.start_date).isAfter(issEnd)) {
                        newMember.start_date = issuance.end_date;
                    }
                }

                if (member.end_date) {
                    if (gnoment(member.end_date).isAfter(issEnd)) {
                        newMember.end_date = issuance.end_date;
                    } else if (gnoment(member.end_date).isBefore(issStart)) {
                        newMember.end_date = issuance.start_date;
                    }
                }

                return newMember;
            });
            const minMemberQuota =
                parseInt(
                    readRuleValue(
                        'MinGroupSize',
                        this.props.permit.rules,
                        issuance.division_id
                    ),
                    10
                ) || 0;
            const maxMemberQuota = getMaxMemberQuota({
                permit: this.props.permit,
                issuance,
            });

            if (groupInfo.length > maxMemberQuota) {
                groupInfo = groupInfo.slice(0, maxMemberQuota);
            } else if (groupInfo.length < minMemberQuota) {
                const differenceInGroupSize = minMemberQuota - groupInfo.length;
                for (let i = 0; i < differenceInGroupSize; i++) {
                    groupInfo.push({ start_date: issuance.start_date });
                }
            }
        }
        return groupInfo;
    };

    dispatchIssuance(item, recaptcha) {
        if (
            this.state.existingReservationId &&
            this.props.issuance &&
            !this.props.fetchIssuanceError
        ) {
            //  use existing issuance and just update field values here
            let issuance = cloneDeep(this.props.issuance);

            issuance.itinerary = item.itinerary;
            issuance.start_date = item.start_date;
            issuance.division_id = item.division_id;
            issuance.end_date = item.end_date;
            issuance.is_modify_quota = true; // used to bypass backend multiple permit per day rule restriction
            issuance.group_info = this.getUpdatedExistingIssuanceGroupMembers(issuance);
            issuance.group_size = issuance.group_info.length;
            issuance.permit_type = item.permit_type;

            issuance = Object.assign(
                issuance,
                addFilterValues(
                    this.state.quotaFilterValues,
                    issuance.group_info,
                    issuance.guides
                )
            );
            // double equipment quotas if we're Pere Marquette
            if (item.permit_id === types.PERE_MARQUETTE_ID) {
                issuance = this.updatePereMarquetteFilter(issuance);
            }

            this.props
                .dispatch(pActions.updateIssuance(issuance))
                .then(() => {
                    this.props.dispatch(
                        pActions.saveFilters(this.state.quotaFilterValues)
                    );
                })
                .then(() => {
                    if (!this.props.updateIssuanceError) {
                        const reservationId = this.state.existingReservationId;
                        let redirectURL = `/permits/${this.props.permit.id}/registration/${reservationId}`;
                        if (
                            this.props.updateIssuanceResult ===
                            types.ISSUANCE_UPDATE_SUCCESSFUL
                        ) {
                            redirectURL = `/account/orders/${this.props.issuance.order_id}/reservations/${reservationId}?updateSuccessful=true`;
                            window.location.assign(redirectURL);
                        } else {
                            this.props.router.navigate(redirectURL);
                        }
                    } else {
                        this.setState({ isLoading: false });
                    }
                })
                .catch(() => {
                    this.focusErrorNotification();
                });
        } else {
            const issuance = { ...item };
            // set first group member name as the one belonging to the account
            if (!SecurityHelper.isCommercialAccount() && get(item.group_info, 'length')) {
                const { first_name, last_name } = SecurityHelper.getAccount();
                const firstGroupMember = {
                    ...issuance.group_info[0],
                    first_name,
                    last_name,
                };
                issuance.group_info[0] = firstGroupMember;
            }

            this.props
                .dispatch(
                    pActions.processBooking({
                        doRedirect: false,
                        item: issuance,
                        recaptcha,
                    })
                )
                .then(() => {
                    this.props.dispatch(
                        pActions.saveFilters(this.state.quotaFilterValues)
                    );
                })
                .then(() => {
                    if (!this.props.issuanceError) {
                        this.props.recaptcha.resetChallenge();
                        this.setState({ isChallengeModalOpen: false });
                        const reservationId = `${this.props.issuance.id}${types.RES_ID_DELIMITER}${this.props.permit.id}`;
                        const redirectURL = `/permits/${this.props.permit.id}/registration/${reservationId}`;
                        this.props.router.navigate(redirectURL);
                    }
                })
                .catch((err) => {
                    const { shouldRetry } =
                        this.props.recaptcha.handleRecaptchaError(err);
                    if (shouldRetry) {
                        this.setState({ isChallengeModalOpen: true, isLoading: false });
                        return;
                    }
                    this.setState({ isChallengeModalOpen: false, isLoading: false });
                    this.focusErrorNotification();
                });
        }
    }

    handleToggleFullView() {
        this.setState((prevState) => ({ toggleFullView: !prevState.toggleFullView }));
    }

    generateDataSource({
        quotaFilterValues = this.state.quotaFilterValues,
        selectedQuotaToDisplay = this.state.selectedQuotaToDisplay,
        permit = this.props.permit,
        aggSeasonRules = this.props.aggSeasonRules,
        availabilities = this.props.availabilities,
        startDate = this.state.detailedAvailabilityStartDate,
        endDate = this.state.detailedAvailabilityEndDate,
    } = {}) {
        if (!permit.divisions || !availabilities) {
            return [];
        }
        const startDateString = startDate.format();
        const endDateString = endDate.format();
        // for every division
        const result = Object.keys(permit.divisions)
            .filter((divisionId) => {
                return (
                    availabilities[divisionId] &&
                    availabilities[divisionId].result &&
                    permit.divisions[divisionId].is_active &&
                    !permit.divisions[divisionId].is_hidden
                );
            })
            .filter((divisionId) => {
                // implements the filter for fire island where we are either 'Beach' or 'Wilderness'
                if (!get(this.props, 'permit.components.permit_section_filter')) {
                    return true;
                }
                const { section } = this.state;
                if (!section) {
                    // hasn't been selected yet ('' is false), display NONE.
                    return false;
                }
                const { permit_sections: permitSections } = this.props.permit;
                const currentDivisions = permitSections.find(
                    (type) => type.name === section
                ).division_ids;
                return currentDivisions.findIndex((div) => div === divisionId) !== -1;
            })
            .map((divisionId, index) => {
                // create a copy of that division
                const division = { ...permit.divisions[divisionId] };

                // assign a view_order if one is not yet set
                if (!division.view_order) {
                    division.view_order = index + 1;
                }
                // assign a stay limit to that division
                let stayLimit =
                    readRuleValue('StayLimit', permit.rules, divisionId) / 24 / 60 / 60; // seconds -> days

                if (shouldIgnoreQuotaAfterFirstDay(availabilities)) {
                    stayLimit = Math.min(stayLimit, 1);
                }
                division.stayLimit = stayLimit;

                const resultingAvailableDays = {
                    ...availabilities[divisionId].result.bools,
                };
                const secretQuotaDays = { ...availabilities[divisionId].result.secret };
                const displayMap = {};
                const quotas = { ...availabilities[divisionId].result.quota_type_maps };
                // and assign to that division transformed availabilities
                Object.keys(availabilities[divisionId].result.quota_type_maps).forEach(
                    (quotaType) => {
                        const filterValue = quotaFilterValues[quotaType];
                        const availabilitiesForQuotaType =
                            availabilities[divisionId].result.quota_type_maps[quotaType];
                        Object.keys(availabilitiesForQuotaType)
                            .sort()
                            .forEach((date) => {
                                if (date < startDateString || date > endDateString) {
                                    return;
                                }
                                const uniformDate = gnoment(date)
                                    .utc()
                                    .format(types.AVAILABILITY_KEY_MAP_FORMAT);
                                // based on the filter value
                                resultingAvailableDays[uniformDate] =
                                    resultingAvailableDays[uniformDate] &&
                                    availabilitiesForQuotaType[date].remaining >=
                                        filterValue;

                                // and on lottery logic
                                resultingAvailableDays[uniformDate] =
                                    resultingAvailableDays[uniformDate] &&
                                    !isDayBlocked(gnoment(date).utc(), {
                                        permit,
                                        dateMap: resultingAvailableDays,
                                        blockLotteryDates: true,
                                        currentDate: gnoment().utcOffset(0, true),
                                        aggSeasonRules,
                                    });
                                // and which availability to display
                                if (quotaType === selectedQuotaToDisplay) {
                                    const isBeforeToday = gnoment(date)
                                        .utc()
                                        .isBefore(
                                            gnoment()
                                                .utc()
                                                .startOf('day')
                                                .subtract(1, 'day')
                                        );

                                    displayMap[uniformDate] =
                                        isBeforeToday ||
                                        !resultingAvailableDays[uniformDate]
                                            ? 0
                                            : availabilitiesForQuotaType[date].remaining;
                                }
                            });
                    }
                );

                return {
                    permit,
                    division,
                    dateMap: resultingAvailableDays,
                    secretMap: secretQuotaDays,
                    displayMap,
                    quotas,
                    aggSeasonRules,
                };
            });
        return result;
    }

    getStayLimit() {
        const seasonStayLimitValue =
            get(this.props, 'divisionStayLimitRule.value', 0) / 24 / 60 / 60;
        return seasonStayLimitValue === 0
            ? Number(
                  readRuleValue(
                      types.STAY_LIMIT_RULE_NAME,
                      this.props.permit.rules,
                      RULE_NOT_SPECIFIC_TO_DIVISION
                  ) / types.DAYS_TO_SECS
              )
            : seasonStayLimitValue;
    }

    updatePereMarquetteFilter(issuance, divide) {
        // overwrite equipments if we are Pere Marquette
        let { equipments } = this.state;
        equipments = equipments.map((e) => {
            if (divide) {
                e.weight /= 2;
            } else {
                e.weight *= 2;
            }
            return e;
        });
        const updatedIssuance = {
            ...issuance,
            ...addFilterValues(this.state.quotaFilterValues),
            ...(equipments && equipments.length && { equipments }),
        };
        return updatedIssuance;
    }

    updateQuotaFilterType(quotaType) {
        this.setState(
            {
                selectedQuotaToDisplay: quotaType,
            },
            () => {
                this.setState({
                    dataSource: this.generateDataSource(),
                });
            }
        );
    }

    updateQuotaFilterValue(quotaType, newValues) {
        const newState = {};
        const newValue = newValues.value;
        const quotaFilterValues = { ...this.state.quotaFilterValues };
        // handle updated value
        if (newValue || newValue === '' || newValue === 0) {
            quotaFilterValues[quotaType] = newValue;
            newState.quotaFilterValues = quotaFilterValues;

            // reset date selection if increasing value
            if (this.state.existingReservationId) {
                const oldValue = this.state.initialQuotaFilterValues[quotaType];
                if (newValue > oldValue) {
                    this.resetSelection();
                }
            }
        }

        // handle equipments for pere marquette
        if (newValues.equipments) {
            newState.equipments = newValues.equipments;
        }
        this.setState(newState, () => {
            this.setState({
                dataSource: this.generateDataSource({ quotaFilterValues }),
            });
        });
    }

    getErrorNotificationProps = () => {
        const errorsList = errorsToStringList([
            this.props.error,
            this.props.updateIssuanceError,
            this.props.issuanceError,
            this.state.lotteryOnlyError,
        ]);
        if (errorsList[0]) {
            return {
                body: errorsList[0],
                isShow: true,
                dismiss: undefined,
            };
        }
        return {
            body: undefined,
            isShow: false,
            dismiss: undefined,
        };
    };

    handleNotificationWarningClose = () =>
        this.setState({ displayWarning: false, warning: '' });

    isShowQuestionaire = () => {
        return (
            this.props.permit.id === types.FOSSIL_CREEK_ID &&
            (this.state.section === 'Fossil Springs Parking (8-mile Hike)' ||
                this.state.section === 'Horse Trailer Parking')
        );
    };

    renderBookNow() {
        const { isLoading, existingReservationId, selectedItinerary, quotaFilterValues } =
            this.state;
        const isDisabled =
            !selectedItinerary ||
            selectedItinerary.length === 0 ||
            getFilterErrors(quotaFilterValues).length;
        const hasExistingReservation =
            typeof existingReservationId === 'string' &&
            existingReservationId.length > 0 &&
            !this.props.fetchIssuanceError;
        const issuanceStatus = get(this.props, 'issuance.status');
        return (
            <BookNow
                hasExistingReservation={hasExistingReservation}
                isDisabled={!!isDisabled}
                isLoading={isLoading}
                numItineraryItems={selectedItinerary.length}
                onCancelClick={() => {
                    this.props.router.navigate(-1);
                }}
                onSaveClick={this.handleRegistration}
                issuanceStatus={issuanceStatus}
            />
        );
    }

    renderPermitSectionPicker() {
        if (!get(this.props, 'permit.components.permit_section_filter')) {
            return null;
        }
        return (
            <DetailedAvailabilityFilterItem mobileLabel="Select Permit type">
                <Select
                    id="division-selection"
                    isLabelVisible={false}
                    label="Permit type"
                    value={this.state.section || ''}
                    onChange={this.handleSectionSelection}
                    placeholder="Select Permit Type..."
                    options={[...this.getSectionOptions()]}
                />
            </DetailedAvailabilityFilterItem>
        );
    }

    renderFilterHeader() {
        const {
            guidesCountTowardsGroupSize,
            contactFacility,
            displayAvailability,
            parkingSelection,
        } = this.state;
        let activeDivisions = [];
        const permitSections = get(this.props, 'permit.permit_sections');
        if (permitSections) {
            const section = permitSections.find((sec) => sec.name === this.state.section);
            activeDivisions = get(section, 'division_ids', []);
        }
        const showQuestionaire = this.isShowQuestionaire();
        const infoRequirements = this.getInformationRequirements();

        return (
            <DetailedAvailabilityFilter>
                <LayoutControlContext.Consumer>
                    {(contextValue) => {
                        const { isMobileApp } = contextValue;
                        const AvailabilityFilterContainer = isMobileApp ? Stack : Inline;
                        const hasTypeQuestion = get(
                            this.props,
                            'permit.components.reservation_type_question'
                        );
                        const showFilters =
                            (displayAvailability && !!contactFacility) ||
                            (displayAvailability && !!parkingSelection) ||
                            (!hasTypeQuestion && !showQuestionaire) ||
                            !isMobileApp;

                        return (
                            <AvailabilityFilterContainer>
                                {hasTypeQuestion && isMobileApp && (
                                    <OrganizedGroupQuestion
                                        contactFacility={contactFacility}
                                        handleAnswerChange={this.handleQuestionResponse}
                                    />
                                )}

                                {isMobileApp && showQuestionaire && this.renderHiking()}

                                {showFilters && (
                                    <>
                                        {this.renderPermitSectionPicker()}
                                        <DetailedAvailabilityFilterItem mobileLabel="Select Date">
                                            <DatePicker
                                                id="jump-date"
                                                isLabelVisible={false}
                                                label={'Select Date'}
                                                numVisibleMonths={1}
                                                defaultValue={gnomentToCalendarDate(
                                                    this.state
                                                        .detailedAvailabilityStartDate
                                                )}
                                                onChange={(day) =>
                                                    this.handleStartDateChange(
                                                        calendarDateToGnoment(day)
                                                    )
                                                }
                                                minValue={localToday}
                                            />
                                        </DetailedAvailabilityFilterItem>
                                        <AvailabilityFilters
                                            permitID={this.props.permit.id}
                                            equipments={this.state.equipments}
                                            quotaFilters={readQuotaFilters(
                                                this.props.availabilities,
                                                this.props.permit,
                                                activeDivisions,
                                                SecurityHelper.isCommercialAccount()
                                            )}
                                            quotaFilterValues={
                                                this.state.quotaFilterValues
                                            }
                                            guidesCountTowardsGroupSize={
                                                guidesCountTowardsGroupSize &&
                                                SecurityHelper.isCommercialAccount()
                                            }
                                            selectedQuotaToDisplay={
                                                this.state.selectedQuotaToDisplay
                                            }
                                            detailedAvailabilityStartDate={
                                                this.state.detailedAvailabilityStartDate
                                            }
                                            jumpDateFocused={this.state.jumpDateFocused}
                                            updateQuotaFilterType={
                                                this.updateQuotaFilterType
                                            }
                                            updateQuotaFilterValue={
                                                this.updateQuotaFilterValue
                                            }
                                            handleJumpDateFocusChange={
                                                this.handleJumpDateFocusChange
                                            }
                                            isMobileApp={isMobileApp}
                                            isGuestCounterDisabled={
                                                infoRequirements.hasTypeRequirement &&
                                                !this.state.section
                                            }
                                        />
                                    </>
                                )}
                                {isMobileApp &&
                                    infoRequirements.isRequired &&
                                    showFilters && (
                                        <DetailedAvailabilityInformationRequired
                                            {...infoRequirements}
                                        />
                                    )}
                            </AvailabilityFilterContainer>
                        );
                    }}
                </LayoutControlContext.Consumer>
            </DetailedAvailabilityFilter>
        );
    }

    renderMain() {
        const { name, id: permitId } = this.props.permit;
        const path = [
            { title: 'Home', url: '/' },
            { title: name, url: `/permits/${permitId}` },
            { title: 'Detailed Availability' },
        ];
        const { body, dismiss, isShow } = this.getErrorNotificationProps();
        const hasTypeQuestion = get(
            this.props,
            'permit.components.reservation_type_question'
        );
        const showQuestionaire = this.isShowQuestionaire();
        const infoRequirements = this.getInformationRequirements();

        return (
            <DetailedAvailabilityPageMain
                breadcrumbPath={path}
                warningBody={this.state.warning}
                warningIsShow={this.state.displayWarning}
                warningDismiss={this.handleNotificationWarningClose}
                errorBody={body}
                errorIsShow={isShow}
                errorDismiss={dismiss}
            >
                {this.renderFilterHeader()}

                <LayoutControlContext.Consumer isAllowOnDetailedAvailability>
                    {({ isMobileApp }) =>
                        !isMobileApp && (
                            <>
                                {hasTypeQuestion && (
                                    <OrganizedGroupQuestion
                                        contactFacility={this.state.contactFacility}
                                        handleAnswerChange={this.handleQuestionResponse}
                                    />
                                )}
                                {showQuestionaire && this.renderHiking()}
                            </>
                        )
                    }
                </LayoutControlContext.Consumer>

                {infoRequirements.isRequired && this.state.displayAvailability && (
                    <DetailedAvailabilityInformationRequired {...infoRequirements} />
                )}

                {this.state.displayAvailability &&
                    !this.state.lotteryOnlyError &&
                    this.renderCalendarSection()}
            </DetailedAvailabilityPageMain>
        );
    }

    renderHiking() {
        return (
            <div className="rec-form-inline-item-wrap">
                <div className="fieldset-question-wrap">
                    <fieldset>
                        <legend>
                            <strong>
                                Be aware that Fossil Springs Parking lot is 8 miles
                                round-trip from Fossil Creek with 1600 ft change in
                                elevation with temperatures exceeding 105 F degrees. Do
                                you want to continue?
                            </strong>
                        </legend>
                        <div className="rec-form-inline-item-wrap">
                            <div className="rec-form-inline-item">
                                <label
                                    htmlFor="prompt-answer-yes1"
                                    className="rec-label-radio"
                                >
                                    <input
                                        className="rec-input-hide"
                                        type="radio"
                                        value="yes"
                                        id="prompt-answer-yes1"
                                        name="prompt-answer-yesno1"
                                        checked={this.state.parkingSelection === 'yes'}
                                        onChange={this.handleHikingChange}
                                        placeholder="Yes"
                                    />
                                    <span className="rec-input-radio" />
                                    Yes
                                </label>
                            </div>
                            <div className="rec-form-inline-item">
                                <label
                                    htmlFor="prompt-answer-no1"
                                    className="rec-label-radio"
                                >
                                    <input
                                        className="rec-input-hide"
                                        type="radio"
                                        id="prompt-answer-no1"
                                        name="prompt-answer-yesno1"
                                        value="no"
                                        checked={this.state.parkingSelection === 'no'}
                                        onChange={this.handleHikingChange}
                                        placeholder="No"
                                    />
                                    <span className="rec-input-radio" />
                                    No
                                </label>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div aria-live="polite">
                    {this.state.parkingSelection === 'no' && (
                        <Alert type="info" hasAriaLive>
                            Choose Vehicle Parking from the dropdown above.
                        </Alert>
                    )}
                </div>
            </div>
        );
    }

    handleHikingChange(event) {
        // Handle the yes or no to inform user of parking notice
        const parkingSelection = event.target.value;
        switch (parkingSelection) {
            case 'yes':
                // User is OK with the parking notice so show availability
                this.setState({ parkingSelection, displayAvailability: true });
                break;
            case 'no':
                // Remove visibility and prompt user to select new parking option
                this.setState({ parkingSelection, displayAvailability: false });
                break;
            default:
                // Reset the parking selection
                this.setState({ parkingSelection: null });
                break;
        }
    }

    skip(duration, temporalUnit) {
        const startDate = this.state.detailedAvailabilityStartDate;
        const newStartDate = startDate.clone().add(duration, temporalUnit);
        this.handleStartDateChange(newStartDate);
    }

    renderAvailabilityNavigator = (daysToSkip) => {
        const {
            detailedAvailabilityStartDate: startDate,
            detailedAvailabilityEndDate: endDate,
            selectedItinerary,
        } = this.state;
        return (
            <DetailedAvailabilityNavigator
                onPrev={() => this.skip(-daysToSkip, 'days')}
                onNext={() => this.skip(daysToSkip, 'days')}
                onNextAvailable={this.handleNextAvailableClick}
                prevText={`Prev ${daysToSkip} Days`}
                nextText={`Next ${daysToSkip} Days`}
                onClearSelection={
                    selectedItinerary.length ? this.handleClearSelection : undefined
                }
                startDate={startDate}
                endDate={endDate}
                isPrevDisabled={isDaySameAsTodayOnUTC(startDate)}
            />
        );
    };

    renderCalendarSection() {
        const {
            dataSource,
            sort,
            detailedAvailabilityStartDate: startDate,
            detailedAvailabilityEndDate: endDate,
            divisionsForCurrentSection,
        } = this.state;
        const { permit, availabilities } = this.props;
        const { permitId } = this.props.router.params;

        return (
            <DetailedAvailabilityGridAndActions>
                <LayoutControlContext.Consumer>
                    {(contextValue) => {
                        const { isMobileApp, isFullView } = contextValue;
                        const isSmallerGrid = shouldUseSmallerGrid(contextValue);
                        const daysToSkip = isSmallerGrid
                            ? types.AVAILABILITY_DAYS_TO_SKIP_MOBILE
                            : types.AVAILABILITY_DAYS_TO_SKIP;
                        const numOfCols = isSmallerGrid
                            ? types.AVAILABILITY_DAYS_TO_DISPLAY_MOBILE
                            : types.AVAILABILITY_DAYS_TO_DISPLAY;
                        return (
                            <>
                                {isMobileApp && (
                                    <Box
                                        className="mb-2 pt-1"
                                        background="extra-light-blue"
                                    >
                                        <AvailabilityTypes
                                            legendItems={{
                                                available: false,
                                                availableNumber: true,
                                                walkup: true,
                                                lottery: true,
                                                unavailable: true,
                                            }}
                                        />
                                    </Box>
                                )}

                                {this.renderAvailabilityNavigator(daysToSkip)}
                                <AvailabilityMonths
                                    numOfCols={numOfCols}
                                    startDate={startDate}
                                />
                                <AvailabilityGrid
                                    divStayLimit={this.props.divisionStayLimitRule}
                                    divisionType={this.getDivisionType()}
                                    dataSource={dataSource}
                                    updateSort={this.handleUpdateSort}
                                    sort={sort}
                                    startDate={startDate}
                                    endDate={endDate}
                                    checkoutNextDay={permit.components.checkout_next_day}
                                    onSelectionChange={this.handleSelection}
                                    onDivisionDetailsClick={
                                        this.handleDivisionDetailsClick
                                    }
                                    selectedItinerary={this.state.selectedItinerary}
                                    stayLimit={this.getStayLimit()}
                                    stayLimitMetadata={get(
                                        this.props,
                                        'divisionStayLimitRule.metadata',
                                        {}
                                    )}
                                    stayLimitRule={readRule(
                                        types.STAY_LIMIT_RULE_NAME,
                                        permit.rules,
                                        RULE_NOT_SPECIFIC_TO_DIVISION
                                    )}
                                    rules={permit.rules}
                                    timeZone={permit.time_zone}
                                    ignoreQuotaAfterFirstDay={shouldIgnoreQuotaAfterFirstDay(
                                        availabilities
                                    )}
                                    handleDisplayWarning={(flag, message) =>
                                        this.setState({
                                            displayWarning: flag,
                                            warning: message,
                                        })
                                    }
                                    overlay={this.getOverlay()}
                                    itineraryStartNextDay={shouldIncrementCheckoutDate(
                                        permit.rules,
                                        divisionsForCurrentSection,
                                        permit.id
                                    )}
                                    allowFlexibleItinerary={readRuleAsBoolean(
                                        types.FLEXIBLE_ITINERARY_ALLOWED,
                                        permit.rules,
                                        RULE_NOT_SPECIFIC_TO_DIVISION
                                    )}
                                    allowSameDayReservation={readRuleAsBoolean(
                                        types.IS_SAME_DAY_TRIP_ITINERARY_ALLOWED_RULE_NAME,
                                        permit.rules,
                                        RULE_NOT_SPECIFIC_TO_DIVISION
                                    )}
                                    numOfCols={numOfCols}
                                    isSmallerGrid={isSmallerGrid}
                                    isFullView={isFullView}
                                    permitId={permitId}
                                >
                                    <Box className="pt-1" background="white">
                                        {this.renderAvailabilityNavigator(daysToSkip)}
                                        <AvailabilityMonths
                                            numOfCols={numOfCols}
                                            startDate={startDate}
                                        />
                                    </Box>
                                </AvailabilityGrid>

                                {this.renderBookNow()}
                            </>
                        );
                    }}
                </LayoutControlContext.Consumer>
            </DetailedAvailabilityGridAndActions>
        );
    }

    renderSide() {
        const divisions = Object.keys(this.props.permit.divisions);
        const entryDateOnly = isEntryDateOnly(this.props.permit.rules, divisions);
        return (
            <DetailedAvailabilityPageSide>
                <TripItinerary
                    renderFullItinerary={!entryDateOnly}
                    equipments={this.state.equipments}
                    itinerary={this.state.selectedItinerary}
                    existingItinerary={this.state.existingItinerary}
                    renderExistingItinerary={
                        this.state.existingReservationId !== '' &&
                        this.state.existingItinerary.length > 0
                    }
                    incrementCheckoutDate={shouldIncrementCheckoutDate(
                        this.props.permit.rules,
                        this.state.divisionsForCurrentSection,
                        this.props.permit.id
                    )}
                    name={this.props.permit.name}
                    errors={getFilterErrors(this.state.quotaFilterValues)}
                />
            </DetailedAvailabilityPageSide>
        );
    }

    renderUnauthModal() {
        return (
            <UnauthorizedErrorModal
                isOpen={this.state.showCommercialAuthModal}
                closeModal={() => {
                    this.setState({ showCommercialAuthModal: false });
                    this.props.router.navigate(`/permits/${this.props.permit.id}`);
                }}
            />
        );
    }

    render() {
        if (!this.state.lotteryOnlyError) {
            // if there's this error, let the users see the page w/ the error msg
            if (
                !this.props.permit ||
                this.props.router.params.permitId !== this.props.permit.id ||
                !(
                    this.props.availabilities &&
                    Object.keys(this.props.availabilities).length > 0
                )
            ) {
                return (
                    <div className="permit-loading-wrapper">
                        <Spinner />
                    </div>
                );
            }
        }

        const { isRequired } = this.getInformationRequirements();
        return (
            <DetailedAvailabilityPageLayout isInformationRequired={isRequired}>
                <DivisionDetailsModal
                    permit={this.props.permit}
                    divisionId={this.state.selectedDivisionId}
                    isOpen={this.state.isDivisionDetailsModalOpen}
                    onRequestClose={this.closeDivisionDetailsModal}
                    permitMapping={this.props.permitMapping}
                />
                {this.renderMain()}
                {this.renderSide()}
                {this.renderUnauthModal()}
                <RecaptchaChallengeModal
                    isOpen={this.state.isChallengeModalOpen}
                    onClose={() => this.setState({ isChallengeModalOpen: false })}
                    onContinue={() => this.navigateToRegistration()}
                    recaptcha={this.props.recaptcha}
                    isSubmitting={this.state.isLoading}
                    action={recaptchaConstants.CH_AVAILABILITY_BOOKING}
                />
            </DetailedAvailabilityPageLayout>
        );
    }
}

function select(state) {
    return {
        permit: state.permit.result,
        account: state.auth.account,
        issuance: state.permit.issuance,
        availabilities: state.permit.availabilities,
        availabilityFetching: state.permit.fetching_availability,
        divisionStayLimitRule: state.permit.rule_staylimit,
        error: state.permit.error,
        issuanceError: state.permit.issuanceError,
        fetchIssuanceError: state.permit.fetch_issuance_error,
        updateIssuanceError: state.permit.update_issuance_error,
        updateIssuanceResult: get(state, 'permit.update_issuance_result'),
        aggSeasonRules: state.permit.agg_season_rules,
        nextAvailableDate: state.permit.next_available,
        nextAvailableError: state.permit.next_available_err,
        permitMapping: permitContentSelector.permitMapping(state),
    };
}

export default withCompatRouter(
    connect(select)(withRecaptchaFallback(DetailedAvailabilityPage))
);
